import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import Profile from "../../../../shared/ProfileForm/Profile";
import CloseIcon from "@mui/icons-material/Close";

function OperatorModal({ open, onClose, modalRef, operatorData }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      ref={modalRef}
      maxWidth="xl"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          overflowX: "hidden", // ← якщо контент ширший за екран
        },
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 2,
            right: -1,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box className="rmui-card">
          <Profile
            operatorId={operatorData?.id}
            operatorData={operatorData}
            disableFetch
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default OperatorModal;
